import { useQuery, useQueryClient } from "react-query";
import {
  getActivityLogDetails,
  getActivityLogDetailsRecords,
  getActivityLogModules,
  getActivityLogs,
  getBusiness,
  getSecurityQuestions,
  getTeamMembers,
  getUserSecurityQuestion,
} from "../../../services/settings";
import { getProfileDetails } from "../../../services/auth";
import { useDispatch } from "react-redux";
import { setProfileDetails } from "../../../store/modules/profile";
import { combineActivityLogs } from "../../../helpers";

export const useGetUserList = (isEnabled = true) => {
  return useQuery(
    ["getTeamMembers"],
    () => getTeamMembers().then((res) => res?.data?.data),
    {
      staleTime: Infinity,
      enabled: isEnabled,
    },
  );
};

export const useGetProfileDetails = (parameters) => {
  const accessToken = parameters?.accessToken;
  const isProfileEnabled = parameters?.isProfileEnabled;
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  if (accessToken) queryClient.invalidateQueries(["getProfileDetails"]);
  return useQuery(
    ["getProfileDetails"],
    () =>
      getProfileDetails(accessToken).then((res) => {
        if (res?.data?.data) dispatch(setProfileDetails(res?.data?.data));
        return res?.data?.data;
      }),
    {
      staleTime: Infinity,
      enabled: isProfileEnabled,
    },
  );
};

export const useGetBusinessDetails = () => {
  const dispatch = useDispatch();
  return useQuery(
    ["getBusiness"],
    () =>
      getBusiness().then((res) => {
        if (res?.data?.data) dispatch(setProfileDetails(res?.data?.data));
        return res?.data?.data;
      }),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetUserSecurityQuestion = () => {
  return useQuery(
    ["getUserSecurityQuestion"],
    () => getUserSecurityQuestion().then((res) => res?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetSecurityQuestions = () => {
  return useQuery(
    ["getSecurityQuestions"],
    () => getSecurityQuestions().then((res) => res?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetActivityLogs = ({ queries }) => {
  return useQuery(["getActivityLogs", queries], () =>
    getActivityLogs(queries).then((res) => res?.data),
  );
};

export const useGetActivityLogModules = () => {
  return useQuery(
    ["getActivityLogModules"],
    () => getActivityLogModules().then((res) => res?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetActivityLogDetails = ({ id }) => {
  return useQuery(
    ["getActivityLogDetails", `${id}`],
    () => getActivityLogDetails(id).then((res) => res?.data?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetActivityLogDetailsRecords = ({ id }) => {
  return useQuery(
    ["getActivityLogDetailsRecords", `${id}`],
    () =>
      getActivityLogDetailsRecords(id).then((res) => {
        const newData = combineActivityLogs(res?.data?.data);

        return { data: newData, meta: res?.data?.meta };
      }),
    {
      staleTime: Infinity,
    },
  );
};
